export enum EventTypes {
  PageRendered = 'pageRendered',
  CheckboxChecked = 'checkboxChecked',
  LogoutClicked = 'logoutClicked',
  ReactivateClicked = 'reactivateClicked',
  ParentVerificationClicked = 'parentVerificationClicked',
  EmailVerificationClicked = 'emailVerificationClicked',
  TermsOfUseClicked = 'termsOfUseClicked',
  AppealsProcessClicked = 'appealsProcessClicked',
  CommunityGuidelineClicked = 'communityGuidelineClicked',
  AppealsPortalClicked = 'appealsPortalClicked'
}

export enum EventContext {
  NotApprovedPage = 'NotApprovedPage'
}

export const EVENT_NAME = 'NotApprovedPageEvent';

export const PLATFORM = 'WebApp';
